import { Trans } from '@lingui/macro'
import { MAX_WIDTH_MEDIA_BREAKPOINT } from 'components/Tokens/constants'
import { ITopTrades } from 'graphql/competition/TopTrader'
import { PAGE_SIZE } from 'graphql/data/TopTokens'
import { ReactNode } from 'react'
import { AlertTriangle } from 'react-feather'
import styled from 'styled-components/macro'

import { TopTradersHeaderRow, TopTradersLoadingRow, TopTradersRow } from './Row'

const GridContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: ${MAX_WIDTH_MEDIA_BREAKPOINT};
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  border-radius: 12px;
  justify-content: center;
  align-items: center;
  background: ${({ theme }) => theme.backgroundSwap};
  border: 1px solid ${({ theme }) => theme.backgroundSwapOutline};
  box-shadow: ${({ theme }) => theme.backgroundSwapShadow};
`

const TokenDataContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  height: 100%;
  width: 100%;
`

const NoTokenDisplay = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 60px;
  color: ${({ theme }) => theme.textSecondary};
  font-size: 16px;
  font-weight: 500;
  align-items: center;
  padding: 0px 28px;
  gap: 8px;
`

function NoTokensState({ message, id }: { message: ReactNode; id: string }) {
  return (
    <GridContainer id={id}>
      <TopTradersHeaderRow />
      <NoTokenDisplay>{message}</NoTokenDisplay>
    </GridContainer>
  )
}

const LoadingRows = ({ rowCount }: { rowCount: number }) => (
  <>
    {Array(rowCount)
      .fill(null)
      .map((_, index) => {
        return <TopTradersLoadingRow key={index} first={index === 0} last={index === rowCount - 1} />
      })}
  </>
)

function LoadingTokenTable({ rowCount = PAGE_SIZE, id }: { rowCount?: number; id: string }) {
  return (
    <GridContainer id={id}>
      <TopTradersHeaderRow />
      <TokenDataContainer>
        <LoadingRows rowCount={rowCount} />
      </TokenDataContainer>
    </GridContainer>
  )
}

interface Props {
  topTrades: ITopTrades
}
export default function TopTraders({ topTrades }: Props) {
  const { data: users, isLoading, error } = topTrades

  /* loading and error state */
  if (isLoading) {
    return <LoadingTokenTable id="top-traders" rowCount={PAGE_SIZE} />
  } else if (error) {
    return (
      <NoTokensState
        id="top-traders"
        message={
          <>
            <AlertTriangle size={16} />
            An error occurred loading your trades. Please try again.
            <p>{error.message}</p>
          </>
        }
      />
    )
  } else if (users.length === 0) {
    return <NoTokensState id="top-traders" message={<Trans>You have no trades</Trans>} />
  } else {
    return (
      <GridContainer id="top-traders">
        <TopTradersHeaderRow />
        <TokenDataContainer>
          {users.slice(0, 10).map(
            (item, index) =>
              item?.id && (
                <TopTradersRow
                  key={item.id}
                  tokenListIndex={index}
                  tokenListLength={users.length}
                  //@ts-ignore
                  data={item}
                  // sparklineMap={sparklines}
                  //@ts-ignore
                  sortRank={index + 1}
                />
              )
          )}
        </TokenDataContainer>
      </GridContainer>
    )
  }
}
